var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-portal-tasks"},[(!_vm.isStudent)?_c('ed-homeworks-container'):_vm._e(),(_vm.isStudent)?_c('ed-courses'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }